import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "c-co-pagination"
}
const _hoisted_2 = { class: "limit" }
const _hoisted_3 = { class: "pagination" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  style: {"display":"inline-block","margin-left":"16px","color":"var(--color-secondary-label)"}
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 0,
  style: {"display":"inline-block","margin-right":"16px","color":"var(--color-secondary-label)"}
}
const _hoisted_9 = { class: "rest__info" }
const _hoisted_10 = { class: "rest__info-page" }
const _hoisted_11 = { class: "rest__info-actions" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]

import {computed, ref, watch} from 'vue'
import {ArrowNarrowLeft, ArrowNarrowRight} from 'utruckin-icons'
import type {IPagination} from '@/features/pagination/pagination.types'
import Dropdown from '@/features/pagination/ui/dropdown.vue'

const visibleCount = 7

export default /*@__PURE__*/_defineComponent({
  __name: 'CommonPagination',
  props: {
    meta: {}
  },
  emits: ["change-page", "change-limit"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const limits = computed(() => [
  {name: '10', value: 10},
  {name: '20', value: 20},
  {name: '30', value: 30},
  {name: '40', value: 40},
  {name: '50', value: 50},
  {name: '100', value: 100},
  {name: '200', value: 200},
])

const limit = ref<number>(props.meta?.page_size || 50)

watch(
    () => props.meta?.page_size,
    (newValue) => {
      if (newValue && newValue !== limit.value) {
        limit.value = newValue
      }
    },
    {immediate: true}
)

watch(limit, (newValue, oldValue) => {
  if (newValue !== oldValue) {
    emit('change-limit', Number(newValue))
  }
})

const currentPage = computed(() => props.meta?.page || 1)
const totalPages = computed(() => props.meta?.pages || 0)
const hasPrev = computed(() => currentPage.value > 1)
const hasNext = computed(() => currentPage.value < totalPages.value)

const pages = computed(() => {
  const total = totalPages.value
  const current = currentPage.value

  if (total <= visibleCount) {
    return Array.from({length: total}, (_, i) => i + 1)
  }

  const half = Math.floor(visibleCount / 2)
  let start = current - half
  let end = current + half

  if (visibleCount % 2 === 0) {
    end -= 1
  }

  if (start < 1) {
    start = 1
    end = visibleCount
  }

  if (end > total) {
    end = total
    start = total - visibleCount + 1
  }

  return Array.from({length: end - start + 1}, (_, i) => start + i)
})

function goTo(page: number) {
  if (page < 1 || page > totalPages.value) return
  if (page === currentPage.value) return
  emit('change-page', page)
}

return (_ctx: any,_cache: any) => {
  return (totalPages.value > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(Dropdown, {
            items: limits.value,
            modelValue: limit.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((limit).value = $event))
          }, null, 8, ["items", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          (pages.value[0] > 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (goTo(1)))
                }, "1"),
                (pages.value[0] > 2)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, "..."))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pages.value, (page) => {
            return (_openBlock(), _createElementBlock("button", {
              key: page,
              class: _normalizeClass({ active: page === currentPage.value }),
              onClick: ($event: any) => (goTo(page))
            }, _toDisplayString(page), 11, _hoisted_6))
          }), 128)),
          (pages.value[pages.value.length - 1] < totalPages.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                (pages.value[pages.value.length - 1] < totalPages.value - 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, "..."))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (goTo(totalPages.value)))
                }, _toDisplayString(totalPages.value), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, " Page " + _toDisplayString(currentPage.value) + " of " + _toDisplayString(totalPages.value), 1),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              class: "prev",
              disabled: !__props.meta.prev_page,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (goTo(currentPage.value - 1)))
            }, [
              _createVNode(_unref(ArrowNarrowLeft), { size: 20 })
            ], 8, _hoisted_12),
            _createElementVNode("button", {
              class: "next",
              disabled: !__props.meta.has_more,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (goTo(currentPage.value + 1)))
            }, [
              _createVNode(_unref(ArrowNarrowRight), { size: 20 })
            ], 8, _hoisted_13)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})